import React from "react";
import HomeView from "./HomeView";

const HomeViewController = () => {
    return <HomeView />
}

export default HomeViewController;